import { useEffect } from 'react';
import { META_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import MESSAGE_TYPES from '../constants/MESSAGE_TYPES';
import useTranslate from './useTranslate';

const useTableSelectorBack = () => {
  const resetSector = () => window.Widget.metaController.emit(META_EVENTS.CHANGE_SECTOR, null);
  const { t, transliterate } = useTranslate();

  const onMessageReceived = (event) => {
    if (event.data.type === MESSAGE_TYPES.EXIT_TABLE_SECTOR) resetSector();
  };

  useEffect(() => {
    window.addEventListener('message', onMessageReceived, false);
    return () => window.removeEventListener('message', onMessageReceived, false);
  }, []);

  return { t, transliterate, resetSector };
};

export default useTableSelectorBack;
